import { Link } from 'react-router-dom'
import { Construction, ArrowLeft } from 'lucide-react'
import { Chip } from './Chip'
import { t } from '@/lib/ui'
import { useDocumentTitle } from '@/lib/useDocumentTitle'

// Consistent placeholder for routes later WPs will build, so the site is
// deployable from day one (WP-E1 task 4). Bilingual "Rakenteilla / Under
// construction" per the brief; names the building WP (the site is transparent
// about its own machinery — that is the point of the exercise).

interface UnderConstructionProps {
  title: string
  buildWp: string
}

export function UnderConstruction({ title, buildWp }: UnderConstructionProps) {
  useDocumentTitle(title)
  return (
    <div className="mx-auto max-w-shell px-4 py-20">
      <div className="mx-auto max-w-prose">
        <Construction className="h-8 w-8 text-accent" aria-hidden="true" />
        <div className="mt-4">
          <Chip variant="soft">{t('underConstruction.badge')} · Under construction</Chip>
        </div>
        <h1 className="mt-4 text-3xl font-semibold tracking-tight text-ink">{title}</h1>
        <p className="mt-3 text-lg leading-relaxed text-muted">{t('underConstruction.body')}</p>
        <p className="mt-2 text-sm text-muted">
          <span className="font-mono">{buildWp}</span>
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-1.5 text-accent underline decoration-hairline underline-offset-2 hover:decoration-accent"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden="true" />
          {t('underConstruction.back')}
        </Link>
      </div>
    </div>
  )
}
